import(/* webpackMode: "eager" */ "/codebuild/output/src1537574305/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
